import { QRCodeSVG } from 'qrcode.react';

/** Mark with ~10px white padding + 8px rounded plate (see public/totalequip-iq-mark-qr.svg). */
const LOGO_SRC = '/totalequip-iq-mark-qr.svg';
const LOGO_ASPECT = 122 / 100;
/** Extra modules cleared around the logo plate so the white pad reads clearly. */
const EXCAVATE_PAD_PX = 4;

interface EquipIQQRCodeProps {
    value: string;
    size?: number;
    className?: string;
    /** Logo plate size as a fraction of the QR size (default ~24%). */
    logoRatio?: number;
}

/**
 * Equipment QR with TotalEquipIQ mark centered (error-correction H + excavate).
 */
export const EquipIQQRCode = ({ value, size = 125, className, logoRatio = 0.24 }: EquipIQQRCodeProps) => {
    const logoHeight = Math.round(size * logoRatio) + EXCAVATE_PAD_PX * 2;
    const logoWidth = Math.round(logoHeight * LOGO_ASPECT);

    return (
        <QRCodeSVG
            bgColor="#ffffff"
            fgColor="#000000"
            includeMargin={false}
            level="H"
            size={size}
            value={value}
            className={className}
            imageSettings={{
                src: LOGO_SRC,
                height: logoHeight,
                width: logoWidth,
                excavate: true,
            }}
        />
    );
};
